import React, { useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import moment from "moment";

const ProjectRemarksTab = ({
  // Data
  remarks,
  remarksLoading,

  // Edit states
  editingRemarkId,
  editingRemarkText,
  updatingRemark,

  // Input states
  remarkText,
  addingRemark,

  // Permissions
  hasEditPermission,

  // Handlers
  setRemarkText,
  handleAddRemark,
  startEditRemark,
  cancelEditRemark,
  setEditingRemarkText,
  handleUpdateRemark,
}) => {
  // Add useEffect to log when remarks prop changes
  useEffect(() => {
    console.log("=== ProjectRemarksTab received remarks prop ===");
    console.log("remarks array:", remarks);
    console.log("remarks length:", remarks?.length);

    if (remarks && remarks.length > 0) {
      console.log("First remark in props:", remarks[0]);
      console.log("createdBy in first remark:", remarks[0].createdBy);
      console.log("createdByName in first remark:", remarks[0].createdByName);
      console.log("remarkText in first remark:", remarks[0].remarkText);
    }
  }, [remarks]);

  return (
    <div className="project-view-fade-in">
      <Card>
        <Card.Body>
          <h5 className="mb-3">Project Remarks</h5>

          {/* Add Remark - Only for users with edit permission */}
          {hasEditPermission() && (
            <div className="d-flex mb-3">
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Add a remark..."
                value={remarkText}
                onChange={(e) => setRemarkText(e.target.value)}
              />
              <Button
                variant="primary"
                className="ms-2"
                onClick={handleAddRemark}
                disabled={addingRemark}
              >
                {addingRemark ? "Adding..." : "Add"}
              </Button>
            </div>
          )}

          {/* Remarks List */}
          {remarksLoading ? (
            <p>Loading remarks...</p>
          ) : remarks.length === 0 ? (
            <p className="text-muted">No remarks yet.</p>
          ) : (
            <div>
              {(Array.isArray(remarks) ? remarks : []).map((remark, index) => {
                console.log(`Rendering remark ${index}:`, remark);
                return (
                  <Card key={remark.guid || index} className="mb-2">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          {/* Use createdByName if available, fallback to createdBy */}
                          <strong>
                            {console.log(
                              `Display name for ${index}:`,
                              remark.createdByName || remark.createdBy,
                            )}
                            {remark.createdByName || remark.createdBy}
                          </strong>
                          <small className="text-muted ms-2">
                            {remark.createdOn
                              ? moment(remark.createdOn).format(
                                  "DD MMM YYYY HH:mm",
                                )
                              : moment(
                                  remark.createdOnDate?.split("T")[0] +
                                    " " +
                                    remark.createdOnTime,
                                ).format("DD MMM YYYY HH:mm")}
                          </small>
                        </div>
                        {/* Edit button - Only show for users with edit permission */}
                        {hasEditPermission() &&
                          editingRemarkId !== remark.guid && (
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => startEditRemark(remark)}
                              title="Edit remark"
                            >
                              Edit
                            </Button>
                          )}
                      </div>

                      {/* Edit Mode */}
                      {editingRemarkId === remark.guid ? (
                        <div className="mt-2">
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={editingRemarkText}
                            onChange={(e) =>
                              setEditingRemarkText(e.target.value)
                            }
                            className="mb-2"
                          />
                          <div className="d-flex gap-2">
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() =>
                                handleUpdateRemark(
                                  remark.guid,
                                  editingRemarkText,
                                )
                              }
                              disabled={updatingRemark}
                            >
                              {updatingRemark ? "Saving..." : "Save"}
                            </Button>
                            <Button
                              variant="secondary"
                              size="sm"
                              onClick={cancelEditRemark}
                              disabled={updatingRemark}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="mt-2">
                          {console.log(
                            `Displaying remark text:`,
                            remark.remarkText || remark.remarks,
                          )}
                          {remark.remarkText || remark.remarks}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                );
              })}
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProjectRemarksTab;
